<template>
  <div id="ai-screen" :key="refreshKey" class="ai-screen-wrap" data-sidebar="3">
    <div class="ai-screen-top" data-position="0" data-name="LivePhoto消除">
      <PlusImage class="ai-screen-img" :src="bgImg" />
      <!-- <div v-if="isPC" class="ai-slogan ai-slogan-pc ffm600">更懂你，一用就AI上</div> -->
      <AnimationText
        v-if="isPC"
        class="ai-slogan-animate-text ffm600"
        text="更懂你，一用就AI上"
        :themeColor="themeColor"
        endColor="#0186F7"
        :colorPosition="colorPosition"
        :fontSize="96"
        :lineHeight="115.2"
        :startTrigger="`top+=115 bottom`"
        :endTrigger="'top 10%'"
        :activateRatio="0"
        :activateDelay="200"
        :gsapProgress="0.8"
        originLinerCssStyle="linear-gradient(90deg, #0186F7 0%, #B074F4 74%, #E9695D 92%, #ED6C15 100%), linear-gradient(270deg, rgba(252, 252, 252, 0.67) 0%, #FFFFFF 100%)"
      />
      <div v-else-if="isPad" class="ai-slogan ffm600" v-animate>
        更懂你，一用就AI上
      </div>
      <div v-else class="ai-slogan ffm600" v-animate>
        <p class="p1">更懂你，</p>
        <p>一用就AI上</p>
      </div>

      <div class="ai-feature">
        <div class="feature-desc-wrap" v-animate>
          <div class="feature-title ffm500">Live Photo AI消除</div>
          <div class="feature-subtitle ffm600">
            <p>圈一下，</p>
            <p>路人消失</p>
          </div>
        </div>
        <video
          v-if="isPC"
          class="feature-video"
          :src="VIDEO.livephoto"
          loop
          muted
        ></video>
        <div class="feature-desc ffm400" v-animate>
          <p>不想要的路人，圈一下就消失，</p>
          <p>让你的Live Photo干净又好看。</p>
        </div>
      </div>
    </div>
    <div class="ai-screen-bottom">
      <!-- ai功能 -->
      <div
        id="ai-search"
        class="ai-function-item"
        data-position="1"
        data-name="小V圈搜2.0"
        v-animate
      >
        <div class="function-content">
          <div class="function-title ffm500">小V圈搜2.0</div>
          <div class="function-subtitle ffm600">少一步操作，多一份轻松</div>
          <div class="function-desc ffm400">
            开启小V圈搜，屏幕上的链接、商品、地址……就能智能识别，小V懂你所需，点击服务气泡，服务一步直达。
          </div>
        </div>
        <div class="function-img">
          <PlusImage class="function-bg" :src="vSearchImg" />
        </div>
      </div>
      <div
        id="ai-memory"
        class="ai-function-item"
        data-position="2"
        data-name="小V记忆2.0"
        v-animate
      >
        <div class="function-content function-content-v">
          <div class="function-title ffm500">小V记忆2.0</div>
          <div class="function-subtitle ffm600">收藏不怕乱，随时翻得到</div>
          <div class="function-desc ffm400">
            通过双指长按识屏等方式添加收藏，小V记忆会智能归类内容、生成结构化摘要，还能提供关联日程、地址等后项服务。
          </div>
        </div>
        <div class="function-img function-img-v">
          <PlusImage class="function-bg" :src="vMemoryImg" />
        </div>
      </div>
      <div
        class="ai-function-other"
        data-position="3"
        data-name="vivo输入法"
        v-animate
      >
        <div class="other-item other-item2">
          <div class="other-content">
            <div class="other-title ffm500">vivo输入法</div>
            <div class="other-subtitle ffm600">有记忆，更好用</div>
            <div class="other-desc ffm400">
              小V记忆中的常用信息能轻松导入vivo输入法常用语，日常聊天输入关键词时，就能自动联想并调用相关常用语。
            </div>
          </div>
          <div class="other-img">
            <PlusImage class="function-bg" :src="vInputMethod" />
          </div>
        </div>
        <div class="other-item">
          <div class="other-content">
            <div class="other-title ffm500">AI搜索</div>
            <div class="other-subtitle ffm600">一句话，直达结果</div>
            <div class="other-desc ffm400">
              在文件管理、电子邮件、原子笔记等应用内，想找什么、想问什么，只需简单描述几句，AI就能快速给出结果。
            </div>
          </div>
          <div class="other-img">
            <PlusImage class="function-bg" :src="aiSearch" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimationText from "@/components/AnimationText.vue";
import { initExposureTrack } from "@/utils/track.js";
import { mapGetters } from "vuex";
import { AI_SCREEN } from "@/config/image.js";
import VIDEO from "@/config/video";
import { gsap, ScrollTrigger } from "@/utils/gsapConfig.js";
export default {
  name: "AIScreen",
  components: {
    AnimationText,
  },
  data() {
    return {
      AI_SCREEN,
      VIDEO,
      themeColor: ["#ED6C15", "#E9695D", "#B074F4", "#0186F7"],
      colorPosition: [0, 74, 92, 100],
      refreshKey: 1,
    };
  },
  computed: {
    ...mapGetters(["isMobile", "isPad", "isPC"]),
    bgImg() {
      if (this.isMobile) {
        return this.AI_SCREEN.bgH5;
      } else if (this.isPad) {
        return this.AI_SCREEN.bgPad;
      } else {
        return this.AI_SCREEN.bg;
      }
    },
    livephotoImg() {
      if (this.isPC) {
        return this.AI_SCREEN.livephoto;
      } else {
        return this.AI_SCREEN.livephotoH5;
      }
    },
    vSearchImg() {
      if (this.isPC) {
        return this.AI_SCREEN.vSearch;
      } else if (this.isPad) {
        return this.AI_SCREEN.vSearchPad;
      } else {
        return this.AI_SCREEN.vSearchH5;
      }
    },
    vMemoryImg() {
      if (this.isPC) {
        return this.AI_SCREEN.vMemory;
      } else if (this.isPad) {
        return this.AI_SCREEN.vMemoryPad;
      } else {
        return this.AI_SCREEN.vMemoryH5;
      }
    },
    aiSearch() {
      if (this.isPC) {
        return this.AI_SCREEN.aiSearch;
      } else if (this.isPad) {
        return this.AI_SCREEN.aiSearchPad;
      } else {
        return this.AI_SCREEN.aiSearchH5;
      }
    },
    vInputMethod() {
      if (this.isPC) {
        return this.AI_SCREEN.vInputMethod;
      } else if (this.isPad) {
        return this.AI_SCREEN.vInputMethodPad;
      } else {
        return this.AI_SCREEN.vInputMethodH5;
      }
    },
  },
  mounted() {
    if (this.isPC) {
      // this.initScrollColorAnimation();
      this.initVideoscrollTrigger();
    }
    initExposureTrack(".ai-screen-wrap [data-position]")();
    let lastWidth = window.innerWidth;
    this.resizeHandler = () => {
      if (this.isPC) {
        if (Math.abs(window.innerWidth - lastWidth) > 10) {
          lastWidth = window.innerWidth;
          if (this.videoPlayTrigger) {
            this.videoPlayTrigger.kill();
          }
          this.refreshKey++;
          this.$nextTick(() => {
            this.initVideoscrollTrigger();
          });
        }
      }
    };
    window.addEventListener("resize", this.resizeHandler);
  },
  methods: {
    /**
     * 初始化滚动颜色渐变动画
     * 使用GSAP ScrollTrigger监听滚动事件，实现标语颜色的渐变效果
     */
    initScrollColorAnimation() {
      // 获取标语元素
      const sloganElement = this.$el.querySelector(".ai-slogan");

      if (sloganElement) {
        // 创建ScrollTrigger动画
        gsap.to(sloganElement, {
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: sloganElement,
            start: "top 90%", // 当元素顶部距离视口顶部90%时开始动画
            end: "bottom 50%", // 当元素底部距离视口顶部50%时结束动画
            scrub: 1, // 动画与滚动同步，数值越大越平滑
            toggleActions: "play none none reverse", // 进入、离开、重新进入、重新离开时的动作
            onUpdate: (self) => {
              // 根据滚动进度动态改变文字渐变效果
              const progress = self.progress;
              // 计算渐变位置，从左到右移动
              const gradientPosition = progress * 100;
              // 创建从灰色到最终双层渐变的过渡效果
              // 已滚动过的部分显示彩色，未滚动到的部分保持灰色
              const finalGradient = `linear-gradient(90deg, 
                #0186F7 0%, 
                #B074F4 ${(74 * gradientPosition) / 100}%, 
                #E9695D ${(92 * gradientPosition) / 100}%, 
                #ED6C15 ${gradientPosition}%, 
                #ffffff ${gradientPosition}%, 
                #ffffff 100%), 
                linear-gradient(270deg, 
                rgba(252, 252, 252, ${0.67 * (gradientPosition / 100)}) 0%, 
                rgba(255, 255, 255, ${
                  gradientPosition / 100
                }) ${gradientPosition}%, 
                transparent ${gradientPosition}%, 
                transparent 100%)`;

              // 应用渐变背景并设置文字裁剪
              sloganElement.style.background = finalGradient;
            },
          },
        });
      }
    },
    initVideoscrollTrigger() {
      const video = this.$el.querySelector(".feature-video");
      let playPromise;
      this.videoPlayTrigger = ScrollTrigger.create({
        // markers: true,
        trigger: ".ai-screen-top",
        start: "top top",
        end: "bottom top",
        onEnter: () => {
          playPromise = video.play();
        },
        onLeave: () => {
          if (playPromise !== undefined) {
            playPromise.finally((_) => {
              video.pause();
            });
          }
        },
        onEnterBack: () => {
          video.play();
        },
        onLeaveBack: () => {},
      });
    },
  },
  beforeDestroy() {
    // 清理ScrollTrigger实例，避免内存泄漏
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
  },
};
</script>

<style lang="scss" scoped>
.ai-screen-wrap {
  width: 100%;
  position: relative;

  .ai-screen-top {
    width: 100%;
    height: 1200 * $px1920vw + vw;
    padding-top: 140 * $px1920vw + vw;
    overflow: hidden;
    position: relative;
    .ai-screen-img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1; /* 背景图层级设为1 */
    }

    .ai-slogan-animate-text {
      position: relative;
      z-index: 2;
      width: fit-content;
      margin: 0 auto;
    }
    .ai-slogan {
      width: fit-content;
      margin: 0 auto;
      font-size: 96 * $px1920vw + vw;
      line-height: 115.2 * $px1920vw + vw;
      text-align: center;
      background: linear-gradient(
          90deg,
          #0186f7 0%,
          #b074f4 74%,
          #e9695d 92%,
          #ed6c15 100%
        ),
        linear-gradient(270deg, rgba(252, 252, 252, 0.67) 0%, #ffffff 100%);
      -webkit-background-clip: text !important;
      -webkit-text-fill-color: transparent !important;
      background-clip: text !important;
      text-fill-color: transparent !important;
      position: relative;
      z-index: 2; /* 标语层级设为2，显示在背景图上方 */
      &.ai-slogan-pc {
        background: none;
        color: #ffffff;
      }
    }

    .ai-feature {
      display: flex;
      width: 100%;
      margin-top: 174 * $px1920vw + vw;
      position: relative;
      z-index: 2; /* 功能区域层级设为2，显示在背景图上方 */

      .feature-desc-wrap {
        margin-left: 360 * $px1920vw + vw;
        padding-top: 207 * $px1920vw + vw;
        text-align: left;

        .feature-title {
          font-size: 28 * $px1920vw + vw;
          line-height: 34 * $px1920vw + vw;
          color: #0f77ff;
        }

        .feature-subtitle {
          font-size: 64 * $px1920vw + vw;
          line-height: 76.8 * $px1920vw + vw;
          color: #000000;
          margin-top: 12 * $px1920vw + vw;
        }
      }

      .feature-video {
        width: 462 * $px1920vw + vw;
        height: auto;
        position: absolute;
        left: 729 * $px1920vw + vw;
        top: 0;
        object-fit: cover;
        border-radius: 24 * $px1920vw + vw;
      }

      .feature-desc {
        padding-top: 282 * $px1920vw + vw;
        font-size: 18 * $px1920vw + vw;
        line-height: 25.2 * $px1920vw + vw;
        color: rgba(0, 0, 0, 0.6);
        margin-left: 652 * $px1920vw + vw;
        text-align: left;
      }
    }
  }

  .ai-screen-bottom {
    width: 100%;
    background: #f5f5f7;
    padding: 120 * $px1920vw + vw 0;
    font-size: 0;

    .ai-function-item {
      display: flex;
      width: 1200 * $px1920vw + vw;
      height: 600 * $px1920vw + vw;
      overflow: hidden;
      margin: 0 auto 24 * $px1920vw + vw auto;
      border-radius: 24 * $px1920vw + vw;
      background: #ffffff;
      position: relative;

      .function-content {
        padding-top: 210 * $px1920vw + vw;
        padding-left: 48 * $px1920vw + vw;
        text-align: left;
        z-index: 2;

        .function-title {
          font-size: 28 * $px1920vw + vw;
          line-height: 34 * $px1920vw + vw;
          color: #0f77ff;
        }

        .function-subtitle {
          font-size: 40 * $px1920vw + vw;
          line-height: 48 * $px1920vw + vw;
          color: #000000;
          margin-top: 12 * $px1920vw + vw;
        }

        .function-desc {
          font-size: 18 * $px1920vw + vw;
          line-height: 25.2 * $px1920vw + vw;
          color: rgba(0, 0, 0, 0.8);
          margin-top: 24 * $px1920vw + vw;
          width: 380 * $px1920vw + vw;
        }

        &.function-content-v {
          .function-desc {
            width: 445 * $px1920vw + vw;
          }
        }
      }

      .function-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        .function-bg {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
        }

        .function-video {
          position: absolute;
          left: 692 * $px1920vw + vw;
          top: 68 * $px1920vw + vw;
          width: 352 * $px1920vw + vw;
          height: 532 * $px1920vw + vw;
          border-radius: 45 * $px1920vw + vw 45 * $px1920vw + vw 0 0;
          object-fit: cover;
          z-index: 2;
        }
      }

      .function-img-v {
        .function-video {
          position: absolute;
          left: 600 * $px1920vw + vw;
          top: 64 * $px1920vw + vw;
          width: 218 * $px1920vw + vw;
          height: 472 * $px1920vw + vw;
          border-radius: 26 * $px1920vw + vw;
          z-index: 2;
          object-fit: cover;
          &.function-video-2 {
            left: 866 * $px1920vw + vw;
          }
        }
        .function-bg {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
        }
      }
    }

    .ai-function-other {
      display: flex;
      width: 1200 * $px1920vw + vw;
      height: 600 * $px1920vw + vw;
      overflow: hidden;
      margin: 0 auto;
      justify-content: space-between;

      .other-item {
        width: 588 * $px1920vw + vw;
        height: 600 * $px1920vw + vw;
        background: #ffffff;
        border-radius: 24 * $px1920vw + vw;
        position: relative;

        .other-content {
          padding-top: 48 * $px1920vw + vw;
          padding-left: 48 * $px1920vw + vw;
          text-align: left;
          width: 499 * $px1920vw + vw;
          box-sizing: content-box;
          z-index: 2;
          position: relative;

          .other-title {
            font-size: 28 * $px1920vw + vw;
            line-height: 34 * $px1920vw + vw;
            color: #0f77ff;
          }

          .other-subtitle {
            font-size: 40 * $px1920vw + vw;
            line-height: 48 * $px1920vw + vw;
            color: #000000;
            margin-top: 8 * $px1920vw + vw;
          }

          .other-desc {
            font-size: 18 * $px1920vw + vw;
            line-height: 25.2 * $px1920vw + vw;
            color: rgba(0, 0, 0, 0.8);
            margin-top: 16 * $px1920vw + vw;
          }
        }
        .other-img {
          width: 588 * $px1920vw + vw;
          height: 600 * $px1920vw + vw;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          position: absolute;
          left: 0;
          top: 0;
          .function-bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1;
          }
          .other-video {
            width: 222 * $px1920vw + vw;
            height: 368 * $px1920vw + vw;
            margin-top: 238 * $px1920vw + vw;
            z-index: 2;
            position: relative;
            object-fit: cover;
            border-radius: 28 * $px1920vw + vw 28 * $px1920vw + vw 0 0;
          }
        }

        &.other-item2 {
          .other-content {
            padding-top: 409 * $px1920vw + vw;
            width: 481 * $px1920vw + vw;
          }
          .other-img {
            .other-video {
              width: 288 * $px1920vw + vw;
              height: 362 * $px1920vw + vw;
              margin-top: 0 * $px1920vw + vw;
              border-radius: 0 0 36 * $px1920vw + vw 36 * $px1920vw + vw;
            }
          }
        }
      }
    }
  }
}

.isPad {
  .ai-screen-wrap {
    .ai-screen-top {
      width: 100%;
      height: 710 * $px676vw + vw;
      padding-top: 66 * $px676vw + vw;

      .ai-slogan {
        font-size: 42 * $px676vw + vw;
        line-height: 49 * $px676vw + vw;
      }

      .ai-feature {
        display: inline-block;
        margin-top: 0;

        .feature-desc-wrap {
          margin-left: 0;
          padding-top: 75 * $px676vw + vw;
          text-align: center;

          .feature-title {
            font-size: 12 * $px676vw + vw;
            line-height: 14 * $px676vw + vw;
          }

          .feature-subtitle {
            width: 100%;
            font-size: 25 * $px676vw + vw;
            line-height: 29 * $px676vw + vw;
            margin-top: 6 * $px676vw + vw;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .feature-desc {
          margin-left: 0;
          margin-top: 12 * $px676vw + vw;
          text-align: center;
          font-size: 12 * $px676vw + vw;
          line-height: 16 * $px676vw + vw;
          padding: 0 195 * $px676vw + vw;
        }
      }
    }

    .ai-screen-bottom {
      padding: 36 * $px676vw + vw 40 * $px676vw + vw;

      .ai-function-item {
        width: 100%;
        height: 300 * $px676vw + vw;
        margin: 0 auto 20 * $px676vw + vw auto;
        position: relative;

        .function-content {
          padding-top: 99 * $px676vw + vw;
          padding-left: 36 * $px676vw + vw;
          box-sizing: content-box;

          .function-title {
            font-size: 12 * $px676vw + vw;
            line-height: 14 * $px676vw + vw;
            color: #2785ff;
          }

          .function-subtitle {
            font-size: 20 * $px676vw + vw;
            line-height: 23 * $px676vw + vw;
            margin-top: 6 * $px676vw + vw;
            word-break: keep-all;
          }

          .function-desc {
            font-size: 12 * $px676vw + vw;
            line-height: 16 * $px676vw + vw;
            margin-top: 12 * $px676vw + vw;
            width: 220 * $px676vw + vw;
            color: rgba(0, 0, 0, 0.8);
          }
        }

        .function-img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 300 * $px676vw + vw;
          margin-top: 0;
          margin-left: 0;
        }
      }

      .ai-function-other {
        width: 596 * $px676vw + vw;
        height: 360 * $px676vw + vw;
        .other-item {
          width: 288 * $px676vw + vw;
          height: 100%;
          border-radius: 16 * $px676vw + vw;
          .other-content {
            padding-top: 26 * $px676vw + vw;
            padding-left: 22 * $px676vw + vw;
            width: 240 * $px676vw + vw;
            .other-title {
              font-size: 12 * $px676vw + vw;
              line-height: 14 * $px676vw + vw;
            }
            .other-subtitle {
              font-size: 20 * $px676vw + vw;
              line-height: 23 * $px676vw + vw;
              margin-top: 6 * $px676vw + vw;
              word-break: keep-all;
            }
            .other-desc {
              font-size: 12 * $px676vw + vw;
              line-height: 16 * $px676vw + vw;
              margin-top: 12 * $px676vw + vw;
              color: rgba(0, 0, 0, 0.8);
            }
          }
          .other-img {
            width: 288 * $px676vw + vw;
            height: 100%;
          }

          &.other-item2 {
            .other-content {
              padding-top: 231 * $px676vw + vw;
              width: 244 * $px676vw + vw;
            }
          }
        }
      }
    }
  }
}

.isMobile {
  .ai-screen-wrap {
    .ai-screen-top {
      width: 100%;
      height: 660 * $px360vw + vw;
      padding-top: 42 * $px360vw + vw;

      .ai-slogan {
        display: inline-block;
        font-size: 42 * $px360vw + vw;
        line-height: 49 * $px360vw + vw;
        width: 100%;
        .p1 {
          text-align: left;
          padding-left: 108 * $px360vw + vw;
        }
      }

      .ai-feature {
        display: inline-block;
        margin-top: 0;

        .feature-desc-wrap {
          margin-left: 0;
          padding-top: 86 * $px360vw + vw;
          text-align: center;

          .feature-title {
            font-size: 12 * $px360vw + vw;
            line-height: 14 * $px360vw + vw;
          }

          .feature-subtitle {
            width: 100%;
            font-size: 25 * $px360vw + vw;
            line-height: 29 * $px360vw + vw;
            margin-top: 6 * $px360vw + vw;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .feature-desc {
          margin-left: 0;
          margin-top: 12 * $px360vw + vw;
          text-align: center;
          font-size: 12 * $px360vw + vw;
          line-height: 16 * $px360vw + vw;
          padding: 0 37 * $px360vw + vw;
        }
      }
    }

    .ai-screen-bottom {
      padding: 36 * $px360vw + vw 20 * $px360vw + vw;

      .ai-function-item {
        width: 100%;
        height: 360 * $px360vw + vw;
        margin: 0 auto 20 * $px360vw + vw auto;
        position: relative;

        .function-content {
          padding-top: 28 * $px360vw + vw;
          padding-left: 22 * $px360vw + vw;
          padding-right: 22 * $px360vw + vw;
          box-sizing: content-box;

          .function-title {
            font-size: 12 * $px360vw + vw;
            line-height: 14 * $px360vw + vw;
            color: #2785ff;
          }

          .function-subtitle {
            font-size: 20 * $px360vw + vw;
            line-height: 23 * $px360vw + vw;
            margin-top: 6 * $px360vw + vw;
            word-break: keep-all;
          }

          .function-desc {
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
            margin-top: 12 * $px360vw + vw;
            color: rgba(0, 0, 0, 0.8);
            word-break: break-all;
            width: auto;
          }
        }

        .function-img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 360 * $px360vw + vw;
          margin-top: 0;
          margin-left: 0;

          .function-video {
            width: 110 * $px360vw + vw;
            height: 170 * $px360vw + vw;
            position: absolute;
            right: 32 * $px360vw + vw;
            top: 30 * $px360vw + vw;
          }
        }
      }

      .ai-function-other {
        display: inline-block;
        width: 100%;
        height: fit-content;

        .other-item {
          width: 100%;
          height: 360 * $px360vw + vw;
          margin: 0;

          .other-content {
            padding-top: 28 * $px360vw + vw;
            padding-left: 22 * $px360vw + vw;
            padding-right: 22 * $px360vw + vw;
            width: auto;
            box-sizing: content-box;

            .other-title {
              font-size: 12 * $px360vw + vw;
              line-height: 14 * $px360vw + vw;
              color: #2785ff;
            }

            .other-subtitle {
              font-size: 20 * $px360vw + vw;
              line-height: 23 * $px360vw + vw;
              margin-top: 6 * $px360vw + vw;
              word-break: keep-all;
            }

            .other-desc {
              font-size: 12 * $px360vw + vw;
              line-height: 16 * $px360vw + vw;
              margin-top: 12 * $px360vw + vw;
              color: rgba(0, 0, 0, 0.8);
            }
          }
          .other-img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 360 * $px360vw + vw;
            margin-top: 0;
            margin-left: 0;

            .other-video {
              margin-top: 0;
              width: 110 * $px360vw + vw;
              height: 170 * $px360vw + vw;
              position: absolute;
              right: 32 * $px360vw + vw;
              bottom: 0 * $px360vw + vw;
              object-fit: cover;
            }
          }

          &.other-item2 {
            margin: 0 auto 20 * $px360vw + vw auto;
            .other-content {
              padding-top: 229 * $px360vw + vw;
            }
          }
        }
      }
    }
  }
}

@media (prefers-color-scheme: dark) {
  .isPad,
  .isMobile {
    .ai-screen-wrap {
      .ai-screen-bottom {
        background: #222;
        .ai-function-item,
        .ai-function-other .other-item {
          background: #000;
          .function-content,
          .other-content {
            .function-subtitle,
            .other-subtitle {
              color: #fff;
            }
            .function-desc,
            .other-desc {
              color: #eee;
            }
          }
        }
      }
    }
  }
}
</style>
